export default __webpack_public_path__ + "static/media/1st.8e3694df.png";